<ng-container #ratingTemplate>
  <div class="container">
    <div class="d-flex row" [ngSwitch]="ratingType">
      <div class="numeric-rating col-12" [ngStyle]="{ 'font-size': numberFontSize }" *ngSwitchCase="ratingTypes.Number">
        <span
          [class.read-only]="isDisabled"
          [id]="'rat' + ctrl_id"
          class="rating-box"
          *ngFor="let rating of ratings"
          (click)="onRating(rating)"
          (keyup.enter)="onRating(rating)"
          [class.selected]="rating === selectedRating"
          [tabindex]="isDisabled ? -1 : 0"
        >
          {{ rating }}
        </span>
      </div>
      <div class="star-rating col-12" [ngStyle]="{ 'font-size': starFontSize }" *ngSwitchCase="ratingTypes.Star">
        <span
          [class.read-only]="isDisabled"
          [id]="'rat' + ctrl_id"
          class="star"
          [class.preview]="isDisabled === false"
          *ngFor="let rating of ratings"
          (click)="onRating(rating)"
          [class.filled]="rating <= selectedRating"
          (keyup.enter)="onRating(rating)"
          [tabindex]="isDisabled ? -1 : 0"
        >
          &#9733;
        </span>
      </div>
    </div>
  </div>
</ng-container>
